import React, { useCallback } from 'react'
import AutocompleteBase, {
  TAutocompleteBaseChangeHandler,
  IAutocompleteBaseOption,
  TAutocompleteValue,
} from 'transfix-ui/components/AutocompleteBase'
import { makeStyles } from 'transfix-ui/core'

export interface IDemoModeAutocompleteProps {
  onChange: (newVal: TAutocompleteValue | null) => void
  value: string
}

const useStyles = makeStyles(() => ({
  autocomplete: {
    width: '100%',
  },
}))

const modeOptions = [
  { text: 'Demo Mode', id: 'demo' },
  { text: 'Live', id: 'live' },
] as IAutocompleteBaseOption[]

export const DemoModeAutocomplete = ({ onChange, value }: IDemoModeAutocompleteProps) => {
  const classes = useStyles()

  const getModeOption = () => {
    if (value === 'demo') {
      return modeOptions[0]
    }
    return modeOptions[1]
  }

  const changeHandler: TAutocompleteBaseChangeHandler = useCallback(
    (_, newVal) => {
      onChange(newVal)
    },
    [onChange]
  )

  const modeOption = getModeOption()

  return (
    <div className={classes.autocomplete}>
      <AutocompleteBase
        onChange={changeHandler}
        options={modeOptions}
        value={modeOption}
        placeholder='Set demo mode'
      />
    </div>
  )
}
